import * as React from "react";
import { Container } from "reactstrap";

export default () => (
  <Container>
    <h2 className="mt-4">Page not found</h2>
  </Container>
);
